export default __webpack_public_path__ + "static/media/0.b18c130d.jpg";